import React from 'react'
import { AlertProps } from '../types'
import { Button } from './'

export const Alert = ({ children, cta, ctaExternalLink }: AlertProps) => {
  return (
    <div className="flex justify-center bg-gradient-to-r from-purple-1000 to-purple-700 py-2">
      <div className="ml-6 mr-3 flex items-center">
        <h2 className="text-xxs font-normal text-gray-50 md:text-sm">
          {children}
        </h2>
        <div className="ml-4 flex-none">
          <Button to={ctaExternalLink}>{cta}</Button>
        </div>
      </div>
    </div>
  )
}
